import { getFormattedMoney } from "//ringconn.com/cdn/shop/t/192/assets/theme.js?v=122298825136020323051777378003";
class AddOn extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(".addon-card__checkbox");
    if (!this.checkbox) return;
    this.clickHandler = this.handleClick.bind(this);
    this.handleColorSwatchClick = this.handleColorSwatchClick.bind(this);
    this.updateEffectiveDiscount = this.updateEffectiveDiscount.bind(this);
    this.colors = this.querySelectorAll(".color-swatch");
    this.colors.forEach((color) => {
      color.addEventListener("click", this.handleColorSwatchClick);
    });
    this.images = this.querySelectorAll(".addon-card__image");
    this.price = this.querySelector(".addon-card__price--sale");
    this.originalPrice = this.querySelector(".addon-card__price .price--original");
    this.initialPrice = this.price.textContent;
    this.currentSelectedColorId = null;
    this.currentColorInput = null;
  }

  async handleColorSwatchClick(event, id) {
    const swatch = event?.currentTarget;
    const variantId = swatch?.dataset?.variantId || id;
    if (!variantId) return;

    // 获取当前颜色关联的input
    const inputId = swatch.getAttribute("for");
    const colorInput = inputId ? document.getElementById(inputId) : null;

    // 检查是否点击了当前已选中的颜色进行反选
    if (this.currentSelectedColorId === variantId && this.checkbox.checked && colorInput?.checked) {
      // 反选：将addon和当前颜色都设为未选中
      this.checkbox.checked = false;

      // 添加延迟设置颜色input为false
      setTimeout(() => {
        if (colorInput) {
          colorInput.checked = false;
        }
      }, 50);

      // 清除当前记录
      this.currentSelectedColorId = null;
      this.currentColorInput = null;
      await this.getvariant(variantId);
      this.updateVisualState();
      await this.updateTotalPrice(this.variant);
      this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    // 选择新颜色
    const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);
    this.variant = await response.json();
    this.images.forEach((image) => {
      image.style.display = image.id.includes(variantId) ? "block" : "none";
    });
    this.price.textContent = getFormattedMoney(this.variant?.price);
    this.checkbox.value = this.variant.id;

    // 取消之前选中的颜色
    if (this.currentColorInput && this.currentColorInput !== colorInput) {
      this.currentColorInput.checked = false;
    }

    // 记录当前选择的颜色
    this.currentSelectedColorId = variantId;
    this.currentColorInput = colorInput;

    await this.updateEffectiveDiscount();

    this.checkbox.checked = true;
    await this.updateTotalPrice(this.variant);

    // 选中addon

    // 添加延迟设置颜色input为true
    setTimeout(() => {
      if (colorInput) {
        colorInput.checked = true;
      }
    }, 50);

    this.updateVisualState();
    this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  }

  connectedCallback() {
    this.addEventListener("click", this.clickHandler);
    document.addEventListener("tradein:change", this._onExternalChange);
    document.addEventListener("care:change", this._onExternalChange);
    window.addEventListener("pageshow", this._onPageShow);

    // 初始化第一个颜色但不选中addon
    this.initializeFirstColor();

    this.updateVisualState();

    document.addEventListener("variant:change", this.updateEffectiveDiscount);

    // 检查并移动add-on到product-info-2508下方
    this.checkAndMoveToProductInfo();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.clickHandler);
    document.removeEventListener("tradein:change", this._onExternalChange);
    document.removeEventListener("care:change", this._onExternalChange);
    document.removeEventListener("variant:change", this.updateEffectiveDiscount);
    window.removeEventListener("pageshow", this._onPageShow);
  }

  handleClick(event) {
    // 检查点击的是否是 addon-card__label
    if (!event.target.closest(".addon-card__label")) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();

    // Do not toggle if a color swatch or variant picker item was clicked
    if (event.target.closest(".color-swatch") || event.target.closest(".variant-picker__item")) {
      return;
    }

    // 切换选中状态（支持反选）
    if (this.checkbox.checked) {
      // 反选：取消addon选中，同时取消当前颜色选中
      this.checkbox.checked = false;

      // 添加延迟设置颜色input为false
      setTimeout(() => {
        if (this.currentColorInput) {
          this.currentColorInput.checked = false;
        }
      }, 50);
    } else {
      // 选中：如果有记录的颜色，恢复其选中状态
      this.checkbox.checked = true;

      // 添加延迟设置颜色input为true
      setTimeout(() => {
        if (this.currentColorInput) {
          this.currentColorInput.checked = true;
        }
      }, 50);
    }

    // Update styling
    this.updateVisualState();
    this.updateTotalPrice(this.variant);

    // Dispatch a change event so other scripts (like the cart) can listen to it
    this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  }
  async getvariant(variantId) {
    if (variantId) {
      const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);
      this.variant = await response.json();
    }
  }
  async initializeFirstColor() {
    const firstColor = this.colors[0];
    if (firstColor) {
      const variantId = firstColor.dataset.variantId;
      await this.getvariant(variantId);
      if (variantId) {
        this.images.forEach((image) => {
          image.style.display = image.id.includes(variantId) ? "block" : "none";
        });
        this.price.textContent = getFormattedMoney(this.variant?.price);
        this.checkbox.value = this.variant.id;

        // 记录第一个颜色但不选中
        this.currentSelectedColorId = variantId;
        const inputId = firstColor.getAttribute("for");
        this.currentColorInput = inputId ? document.getElementById(inputId) : null;
      }
    }
  }

  updateVisualState() {
    this.classList.toggle("selected", this.checkbox.checked);
  }
  updateTotalPrice(variant) {
    if (!variant) return;
    const initialPriceEl = document.querySelector(".rating-with-text sale-price");
    const salePriceEl = document.querySelector(".product-info__buy-buttons .buy-bottons_price price-list sale-price");
    const compareAtPriceEl = document.querySelector(
      ".product-info__buy-buttons .buy-bottons_price price-list compare-at-price"
    );
    const tradeInEl = document.querySelector('trade-in input[name="tradein-device"]');
    const careEl = document.querySelector('.care-variant[careActive="true"]');

    if (!initialPriceEl || !salePriceEl || !compareAtPriceEl) return;

    const initialPrice = Number(initialPriceEl.dataset.price || 0);
    const tradeInPrice = tradeInEl ? Number(tradeInEl.dataset.devicePrice || 0) : 0;
    const carePrice = careEl ? Number(careEl.dataset.price || 0) : 0;
    const variantPrice = Number(variant?.price || 0);
    const addonPrice = this.ratio * variantPrice;
    const basePrice = this.participate ? initialPrice * this.ratio : initialPrice;

    let totalSalePrice = basePrice + carePrice;
    let totalOriginalPrice = initialPrice + carePrice;
    if (totalSalePrice == 0) return;
    const isChecked = this.checkbox.checked;
    // 处理勾选 checkbox 状态
    if (isChecked) {
      totalSalePrice += addonPrice;
      totalOriginalPrice += variantPrice;
      this.price.textContent = getFormattedMoney(addonPrice);
      this.originalPrice.textContent = getFormattedMoney(variantPrice);
      let show = totalSalePrice == totalOriginalPrice;
      this.originalPrice.style.display = show ? "none" : "block";
      compareAtPriceEl.toggleAttribute("hidden", show);
      this.checkbox.dataset.discount = this.discount;
    } else {
      this.price.textContent = getFormattedMoney(variantPrice);
      this.originalPrice.style.display = "none";
      compareAtPriceEl.setAttribute("hidden", true);
      totalSalePrice = initialPrice + carePrice;

      totalOriginalPrice = initialPrice + carePrice;
    }

    // 处理以旧换新折扣
    if (tradeInPrice > 0) {
      totalSalePrice = initialPrice + carePrice - tradeInPrice + (isChecked ? variantPrice : 0);
      this.price.textContent = getFormattedMoney(variantPrice);
      this.originalPrice.style.display = "none";
      compareAtPriceEl.setAttribute("hidden", true);
      this.checkbox.dataset.discount = "";
    }

    salePriceEl.lastChild.replaceWith(
      document.createRange().createContextualFragment(getFormattedMoney(totalSalePrice))
    );

    compareAtPriceEl.lastChild.replaceWith(
      document.createRange().createContextualFragment(getFormattedMoney(totalOriginalPrice))
    );
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  updateEffectiveDiscount(event) {
    this.color = document.querySelector("variant-option-value[for='option1']").textContent.trim();
    if (this.dataset.colorSpecified.includes(this.color)) {
      this.discount = this.dataset.discountSpecified;
      this.ratio = 1 - Number(this.dataset.discountIntensitySpecified);
      this.specified = true;
      this.participate = this.dataset.participateSpecified === "true";
    } else {
      this.discount = this.dataset.discount;
      this.ratio = 1 - Number(this.dataset.discountIntensity);
      this.specified = false;
      this.participate = this.dataset.participate === "true";
    }
    this.ratio = this.ratio.toFixed(2);
    this.checkbox.checked = this.className.includes("selected");
    this.updateTotalPrice(this.variant);
  }

  checkAndMoveToProductInfo() {
    // 查找当前页面的product-info-2508容器
    const productInfo2508 = document.querySelector(".product-info-2508");
    if (!productInfo2508) {
      return;
    }

    // 检查product-info-2508内是否已经存在add-on
    const existingAddonInProductInfo = productInfo2508.querySelector("add-on");
    if (existingAddonInProductInfo) {
      return;
    }

    // 获取当前add-on元素的最外层容器
    const addonContainer = this.closest(".addon2508");
    if (!addonContainer) {
      return;
    }

    // 将add-on容器移动到product-info-2508的末尾
    try {
      productInfo2508.appendChild(addonContainer);
    } catch (error) {
      console.error("移动add-on时发生错误:", error);
    }
  }

  _onExternalChange = async () => {
    await this.updateTotalPrice(this.variant);
  };

  _onPageShow = () => {
    this.reset();
  };

  reset() {
    if (this.checkbox) {
      this.checkbox.checked = false;
    }
    // 取消所有颜色选项的选中状态
    this.colors.forEach((swatch) => {
      const inputId = swatch.getAttribute("for");
      const colorInput = inputId ? document.getElementById(inputId) : null;
      if (colorInput) {
        colorInput.checked = false;
      }
    });
    this.updateVisualState();
    this.updateTotalPrice(this.variant);
  }
}
if (!window.customElements.get("add-on")) {
  window.customElements.define("add-on", AddOn);
}
